import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  deleteShareholderInvite,
  removeShareHolder,
} from "../../actions/shareHolder";
import { CONTACT_US_TRIGER, POSITIONS } from "../../constants";
import { INVITE_TYPE } from "./shareTable";
import ContactUs from "../ContactUs/ContactUs";

export default function RemoveModal({
  removeModalShow,
  removeModalClose,
  performObj,
  type,
  pendingShareholderList,
}) {
  const dispatch = useDispatch();
  const deleteShareholder = () => {
    if(pendingShareholderList.some(x=>x.email === performObj?.email)){
      const inviteResp = pendingShareholderList.find(x=>x.email === performObj?.email)
      if (performObj.company && inviteResp?.id) {
        dispatch(deleteShareholderInvite(performObj.company._id, inviteResp?.id));
      }
    }else{
      if (performObj.company && performObj.id) {
        dispatch(removeShareHolder(performObj.company._id, performObj.id));
      }
    }
    removeModalClose();
  };
  const getPositionName = (position) => {
    var returnVal = "";
    var filter = POSITIONS.filter((x) => x.value === position);
    if (filter.length > 0) {
      returnVal = filter[0].name;
    }
    return returnVal;
  };
  return (
    <>
      <Modal
        show={removeModalShow}
        onHide={removeModalClose}
        className="custom-modal delete-information-width"
      >
        <div className="modal-header p-0">
          <h5 className="edit-title">
            Are you sure you want to remove this shareholder?
          </h5>
          <button
            type="button"
            className="btn-close text-dark close-button"
            onClick={removeModalClose}
          ></button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-5 mt-3">
              <p className="input-text heading">Shareholder Name</p>
              <span className="col-form-label company-text">
                {performObj.name}
              </span>
            </div>
            <div className="col-lg-3 mt-3">
              <p className="input-text heading">Position</p>
              <span className="col-form-label company-text">
                {getPositionName(performObj.position)
                  ? getPositionName(performObj.position)
                  : "-"}
              </span>
            </div>
          </div>

          <p className="import-note">
            Important note:{" "}
            <span className="will-need-text">
              By proceeding, we will notify you directly and advise you
              accordingly on the next steps to formalise the changes.
            </span>
          </p>

          <div className="modal-footer modal-bottom-action">
            <ContactUs addEditValue="shareholder" type={CONTACT_US_TRIGER.REMOVE_SHARE_DIRETOR_PROMOTER} handleClose={removeModalClose} />
            <button
              type="button"
              onClick={deleteShareholder}
              className="btn agree-button"
            >
              Proceed
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
